import { Component, Input, Renderer2, Output, EventEmitter } from '@angular/core';

import { PaginationProps, paginationStyles, resultsCountStyles } from '@kite_aerolab/shared/components';

import { getBreakpoint } from '@kite_aerolab/shared/utils';
@Component({
  selector: 'kite-pagination',
  templateUrl: './pagination.component.html'
})
export class PaginationComponent {
  breakpoint = getBreakpoint()
  page = 1;
  selectOptions: string[];
  selectDefaultValue: string;
  constructor(private renderer: Renderer2) {
    /* Agrega un listener al evento resize para mantener el breakpoint */
    this.renderer.listen('window', 'resize', () => {
      this.changeBreakpoint();
    });
  }

  /**
   * CSS del componente
   */
   @Input() css: PaginationProps['css'];

  /**
   * PageCount
   */
  @Input() pageCount: PaginationProps['pageCount'];

  /**
   * HasResultsCount
   */
  @Input() hasResultsCount: PaginationProps['hasResultsCount']

  /**
   * ResultsPerPage
   */
  @Input() resultsPerPage: PaginationProps['resultsPerPage']

  /*
  * Function to pass on page change
  **/
  @Output()
  onPageChange = new EventEmitter();
  setPage(newPage : number) {
    if (newPage >= 1 && newPage <= this.pageCount)
      this.page = newPage
      this.selectDefaultValue = newPage.toString()
    if (this.onPageChange) {
      this.onPageChange.emit(newPage)
    }
  }

  handleNextPage() {
    this.setPage(this.page + 1)
  }
  handlePreviousPage() {
    this.setPage(this.page - 1)
  }
  handlePageChange(event: number | string) {
    this.setPage(typeof event === 'number' ? event : parseInt(event))
  }
  changeBreakpoint() {
    this.breakpoint = getBreakpoint();
  }

  ngOnInit () {
    this.selectOptions = Array.from({ length: this.pageCount }, (_, i) => `${i + 1}`)
    this.selectDefaultValue = this.page.toString()
  }
  public get paginationStyles(): string[] {
    return [
      paginationStyles({
      }).className,
    ];
  }

  public get resultsCountStyles(): string[] {
    return [
      resultsCountStyles({
        css: this.css
      }).className,
    ];
  }
}
